import React from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
// eslint-disable-next-line import/no-cycle
import { DeskGroupModel } from '../../api/core/core.types';
import {WithTranslation, withTranslation} from 'react-i18next';

interface DeskGroupModalProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  selectedDeskGroup: DeskGroupModel | null;
  onConfirm: (name: string, description?: string) => void;
  onCancel: () => void;
  onDelete: (id: number) => void;
}

interface DeskGroupModalState {
  nameValue: string;
  descriptionValue: string;
}

class DeskGroupModal extends React.PureComponent<DeskGroupModalProps, DeskGroupModalState> {

  readonly state = {
    nameValue: this.props.selectedDeskGroup ? this.props.selectedDeskGroup.name : '',
    descriptionValue: this.props.selectedDeskGroup ? this.props.selectedDeskGroup.description : ''
  };

  onDelete = () => {
    if (this.props.selectedDeskGroup && this.props.selectedDeskGroup.id) {
      this.props.toggle();
      this.props.onDelete(this.props.selectedDeskGroup.id);
    }
  };

  render() {
    const { t } = this.props;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{ !this.props.selectedDeskGroup ? t('modal.tilte.add_desk_group') :
          'Edit desk group'}</ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column">
            <div className="mb-1">
              <label>{t('l.desk_group.name')}</label>
              <input
                defaultValue={this.props.selectedDeskGroup ? this.props.selectedDeskGroup.name : ''}
                type="text"
                onChange={(e) => this.setState({ nameValue: e.target.value })}
                className="form-control"
              />
            </div>
            <div>
              <label>{t('l.desk_group.description')}</label>
              <input
                defaultValue={this.props.selectedDeskGroup ? this.props.selectedDeskGroup.description : ''}
                type="text"
                onChange={(e) => this.setState({ descriptionValue: e.target.value })}
                className="form-control"
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter className={` d-flex align-items-center ${this.props.selectedDeskGroup ? 'justify-content-between' : 'justify-content-end'}`}>
          {this.props.selectedDeskGroup && (
            <button type="button" disabled={this.props.selectedDeskGroup.deskCount >= 1} className="btn btn-outline-secondary" onClick={this.onDelete}>DELETE</button>
          )}
          <div>
            <button type="button" className="mr-1 btn btn-outline-secondary" color="secondary" onClick={this.props.onCancel}>CANCEL</button>
            <button type="submit" className="btn btn-primary" color="primary" onClick={() => (this.props.onConfirm(this.state.nameValue, this.state.descriptionValue))}>CONFIRM</button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(DeskGroupModal);
